import { App } from "@/atoms"
import { useLogger } from "@/hooks/useLogger"
import { useTranslation } from "@/hooks/useTranslation"
import { LinkOutlined } from "@/icons"
import { CopyButton } from "@/molecules/CopyButton"

import type { ButtonProps } from "@/atoms"
import type { ShareButtonAnalyticsEvent } from "./ShareButton.types"

export const ShareButton = (
  props: Pick<ButtonProps, "size" | "type"> & {
    text?: string
    analyticsEvent?: ShareButtonAnalyticsEvent
  }
) => {
  const { analyticsEvent, ...restProps } = props
  const { message } = App.useApp()
  const { t } = useTranslation()
  const { logger, EVENTS } = useLogger()

  const { name = EVENTS.ANALYTIC_EVENTS.CLICK_SHARE_BUTTON, metadata } =
    analyticsEvent ?? {}

  return (
    <CopyButton
      size="middle"
      type="link"
      icon={<LinkOutlined />}
      text={window.location.href}
      onCopy={() => {
        message.info(t("general.copiedUrl"))
        logger.info(name, metadata)
      }}
      {...restProps}
    >
      {t("general.share")}
    </CopyButton>
  )
}
